package com.holudi.website.util

object Constants {
//    const val SECTION_WIDTH = 800
    const val MAX_WIDTH = 1920
    const val PORTFOLIO_CARD_WIDTH = 400
    const val FONT_FAMILY = "Wix"

    const val LAST_UPDATED_YEAR = "2023"
}